var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSize = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.354 13.418a1.12 1.12 0 0 0 0-1.588l-4.5-4.5a1.124 1.124 0 0 0-1.589 1.589l2.578 2.578H5.525l2.577-2.578A1.124 1.124 0 0 0 6.513 7.33l-4.499 4.495a1.12 1.12 0 0 0 0 1.589l4.5 4.499a1.124 1.124 0 0 0 1.589-1.589l-2.578-2.578h16.314l-2.578 2.578a1.124 1.124 0 0 0 1.589 1.589l4.499-4.5.005.005z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/size.5cf16e0b.svg";
export { ForwardRef as ReactComponent };